import React from 'react';

interface PatternPointLinkProps {
    patternPointId: number;
    patternId: number;
    patternPointLabel: string;
    areaId: number;         // Current area context (required for filtering)
    onClick?: (patternPointId: number, patternId: number, areaId: number) => void;
    style?: React.CSSProperties;
}

/**
 * Reusable component for rendering pattern point names as clickable links
 * When clicked, navigates to a report template filtered by pattern point + pattern + area type
 * Similar to PatternLink and MetricLink but for individual pattern points
 * Preserves hierarchical context: Area → Pattern → Pattern Point
 */
export const PatternPointLink: React.FC<PatternPointLinkProps> = ({ 
    patternPointId,
    patternId,
    patternPointLabel, 
    areaId,
    onClick, 
    style 
}) => {
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (onClick) {
            onClick(patternPointId, patternId, areaId);
        }
    };

    return (
        <a
            href="#"
            onClick={handleClick}
            style={{
                color: '#fa8c16',  // Orange color for pattern points (vs purple for patterns, blue for areas, green for metrics)
                textDecoration: 'none',
                cursor: 'pointer',
                fontWeight: 500,
                ...style,
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = 'underline';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = 'none';
            }}
            title={`View ${patternPointLabel} reports for this area`}
        >
            {patternPointLabel}
        </a>
    );
};

export default PatternPointLink;
